import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionMark from 'components/QuestionMark';
import './styles.scss';

const propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  parent: PropTypes.string.isRequired,
  questionMark: PropTypes.string,
  defaultOpen: PropTypes.bool
};
const defaultProps = {
  className: '',
  parent: 'accordion',
  defaultOpen: false
};

class AccordionItem extends Component {
  render() {
    const { className, children, id, header, parent, questionMark, defaultOpen } = this.props;

    return (
      <div className={`panel panel-default ${className}`}>
        <div className="panel-heading" role="tab" id={`heading-${id}`}>
          <a
            role="button"
            data-toggle="collapse"
            data-parent={`#${parent}`}
            href={`#collapse-${id}`}
            aria-expanded="false"
            aria-controls={`collapse-${id}`}
            className={defaultOpen ? '' : 'collapsed'}
          >
            {header}
            {questionMark && <QuestionMark content={questionMark} />}
          </a>
        </div>
        <div
          id={`collapse-${id}`}
          className={`panel-collapse collapse ${defaultOpen ? 'in' : ''}`}
          role="tabpanel"
          aria-labelledby={`heading-${id}`}
        >
          <div className="panel-body">{children}</div>
        </div>
      </div>
    );
  }
}

AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;

export default AccordionItem;
